"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.lazyLib = exports.lazyX = exports.lazy = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _component = require("@loadable/component");

var _LoadSpinner = require("./LoadSpinner");

/**
 * 组件导入函数,支持自定义加载动画
 * Create a loadable component "Suspense" ready.
 * @param {Function} func 返回动态引入的函数, 如 ()=>import('./a/b/c')
 * @param {Object} options {spinner:spinner, // loading动画组件, 默认为loadSpinner, 其他参数参考LoadSpinner组件}
 * @returns {Component}
 */
var lazy = function lazy(func, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      spinner = _options.spinner,
      restOptions = (0, _objectWithoutPropertiesLoose2["default"])(_options, ["spinner"]);
  var LazyComponent = /*#__PURE__*/(0, _react.lazy)(func);
  return function LazyComponentFunc(props) {
    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: (0, _LoadSpinner.loadSpinner)(spinner, restOptions)
    }, /*#__PURE__*/_react["default"].createElement(LazyComponent, props));
  };
};
/**
 * 组件导入函数,支持自定义加载动画
 * @param {Function} func 返回动态引入的函数, 如 ()=>import('./a/b/c')
 * @param {Object} options {spinner:spinner, // loading动画组件, 默认为loadSpinner, 其他参数参考LoadSpinner组件}
 * @returns {Component}
 */


exports.lazy = lazy;

var lazyX = function lazyX(func, options) {
  if (options === void 0) {
    options = {};
  }

  var _options2 = options,
      spinner = _options2.spinner,
      restOptions = (0, _objectWithoutPropertiesLoose2["default"])(_options2, ["spinner"]);
  var LazyXComponent = (0, _component.lazy)(func);
  return function LazyXComponentFunc(props) {
    return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
      fallback: (0, _LoadSpinner.loadSpinner)(spinner, restOptions)
    }, /*#__PURE__*/_react["default"].createElement(LazyXComponent, props));
  };
};
/**
 * lib动态导入函数
 * @param {Function} func 返回动态引入的函数, 如 ()=>import('abc')
 */


exports.lazyX = lazyX;
var lazyLib = _component.lazy.lib;
exports.lazyLib = lazyLib;